import { render, staticRenderFns } from "./BettingPromotionsTermsModal.vue?vue&type=template&id=c2e379a4"
import script from "./BettingPromotionsTermsModal.vue?vue&type=script&lang=js"
export * from "./BettingPromotionsTermsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports